import { ContentFolderBaseView } from "./ContentFolderBaseView";

interface Props {
  selectedFolderGuid?: string;
  onSelectFolder: (folderGuid?: string) => void;
}

export const ContentFolderView: React.FC<Props> = ({ onSelectFolder, selectedFolderGuid }) => {
  return <ContentFolderBaseView onSelectFolder={onSelectFolder} selectedFolderGuid={selectedFolderGuid} />;
};
